import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import getConfig from 'next/config';
import type { Job, TrackingPixels } from 'types';

import type { Payload as SponsoredJobPayload } from 'hooks/useSponsoredJobs';

const removeApiPath = (path: string) =>
  path.startsWith('/api/') ? path.replace('/api', '') : path;

const {
  publicRuntimeConfig: { HttpRoutes },
} = getConfig();

export const api = createApi({
  reducerPath: 'api',
  baseQuery: fetchBaseQuery({
    baseUrl: '/api',
  }),
  tagTypes: ['API'],
  endpoints: (build) => ({
    getSponsoredJob: build.query<Job, SponsoredJobPayload>({
      query: (body) => ({
        url: removeApiPath(HttpRoutes.fetchSponsoredJobs),
        method: 'POST',
        body,
      }),
      transformResponse: (response: { jobs: Job[] }) => response?.jobs?.[0],
      providesTags: [{ type: 'API', id: 'Sponsored Job' }],
    }),
    getTrackingPixels: build.query<TrackingPixels, void>({
      query: () => ({ url: removeApiPath(HttpRoutes.getTrackingPixels) }),
      transformResponse: (response: TrackingPixels) => response ?? {},
      providesTags: [{ type: 'API', id: 'Tracking Pixels' }],
    }),
  }),
});

export const {
  useLazyGetSponsoredJobQuery,
  useLazyGetTrackingPixelsQuery,
  useGetTrackingPixelsQuery,
} = api;
